import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteTripTypesAdapter = getAdapter({ idFieldName: 'value' });

const quoteTripTypesSlice = createSlice({
  name: 'quoteTripTypes',
  initialState: quoteTripTypesAdapter.getInitialState(),
  reducers: {
    setQuoteTripTypes: (state, { payload: { quoteTripTypes } }) => {
      quoteTripTypesAdapter.setAll(state, quoteTripTypes);
    },
  },
});

const selectors = quoteTripTypesAdapter.getSelectors(({ quoteTripTypes }) => quoteTripTypes);

export const getQuoteTripTypes = (state) => selectors.selectAll(state);

export const {
  setQuoteTripTypes,
} = quoteTripTypesSlice.actions;

export default quoteTripTypesSlice.reducer;
